module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-26.94c6874a.png";